/*
 * `contracts/DESIGN-TOKENS.md` § Shared component patterns. Each badge is a distinct
 * *shape*, not a shared chip in a different colour, which is what keeps canon's "status is
 * never conveyed through colour alone" true without every badge also having to be read.
 */

.badge {
  display: inline-flex;
  align-items: baseline;
  font-family: var(--font-body);
  font-size: 0.6875rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  white-space: nowrap;
}

/* Deal-type signal — a filled pill, the only badge that carries a background. */
.ltd {
  padding: 2px 9px;
  border-radius: var(--radius-pill);
  background: var(--accent-soft);
  color: var(--accent-strong);
}

/* Availability signal — the same pill, outlined rather than filled. */
.exclusive {
  padding: 2px 9px;
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-pill);
  color: var(--text);
}

/*
 * Historical community signal. Not a pill: a Founding Deal is a fact about when a deal
 * joined, not a property of the offer, and it is the quietest of the four.
 */
.founding {
  color: var(--text-muted);
  border-block-end: 1px dotted var(--border-strong);
}

/* Review-status signal — a check and a word, no chrome. */
.verified {
  font-size: 0.71875rem;
  color: var(--positive);
}
